import { useLang } from "@/contexts/LanguageContext";

const STEP_IMAGES = [
  "/produccion-01.jpg",
  "/produccion-02.jpg",
  "/produccion-01.jpg",
  "/produccion-02.jpg",
];

const INGREDIENT_IMAGES = [
  "https://images.unsplash.com/photo-1551446591-142875a901a1?w=800&q=80",
  "https://images.unsplash.com/photo-1518977676601-b53f82aba655?w=800&q=80",
  "https://images.unsplash.com/photo-1611171711791-b34b41b1c5bb?w=800&q=80",
  "https://images.unsplash.com/photo-1532336414038-cf19250c5757?w=800&q=80",
];

const Produccion = () => {
  const { t } = useLang();

  return (
    <div data-testid="page-produccion">
      {/* Header */}
      <section className="px-6 md:px-12 lg:px-20 pt-16 md:pt-24 pb-20 md:pb-28">
        <div className="max-w-[1500px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 items-end">
          <div className="lg:col-span-7">
            <div className="text-[11px] uppercase tracking-[0.3em] text-caramel mb-6 font-medium">
              {t.production.overline}
            </div>
            <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl font-light tracking-tighter leading-[0.95] text-ink whitespace-pre-line">
              {t.production.title}
            </h1>
          </div>
          <div className="lg:col-span-5">
            <p className="text-lg md:text-xl text-ink-muted font-light leading-relaxed">
              {t.production.sub}
            </p>
          </div>
        </div>
      </section>

      {/* Scrollytelling steps */}
      <section className="px-6 md:px-12 lg:px-20 pb-20 md:pb-32">
        <div className="max-w-[1500px] mx-auto space-y-32 md:space-y-48">
          {t.production.steps.map((s, i) => {
            const reversed = i % 2 === 1;
            return (
              <div
                key={i}
                data-testid={`production-step-${i}`}
                className={`grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-20 items-center ${
                  reversed ? "lg:[&>div:first-child]:order-2" : ""
                }`}
              >
                <div className="lg:col-span-7 relative overflow-hidden group">
                  <div className="aspect-square overflow-hidden">
                    <img
                      src={STEP_IMAGES[i % STEP_IMAGES.length]}
                      alt=""
                      className="w-full h-full object-cover transition-transform duration-1000 ease-out group-hover:scale-105"
                    />
                  </div>
                </div>
                <div className="lg:col-span-5">
                  <div className="text-[11px] uppercase tracking-[0.3em] text-caramel mb-5 font-medium">
                    Paso {String(i + 1).padStart(2, "0")} / 04
                  </div>
                  <h3 className="font-serif text-3xl md:text-5xl font-light tracking-tight text-ink leading-tight">
                    {s.t}
                  </h3>
                  <p className="mt-6 text-ink-muted font-light text-base md:text-lg leading-relaxed">
                    {s.d}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      {/* Ingredients */}
      <section className="px-6 md:px-12 lg:px-20 py-24 md:py-32 bg-surface/50 border-t border-b border-bone">
        <div className="max-w-[1500px] mx-auto">
          <div className="text-[11px] uppercase tracking-[0.3em] text-caramel mb-6 font-medium text-center">
            ⟶ {t.production.ingredientsTitle}
          </div>
          <h2 className="font-serif text-4xl md:text-6xl font-light tracking-tight text-ink leading-tight text-center mb-20">
            {t.production.ingredientsTitle}
          </h2>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
            {t.production.ingredients.map((ing, i) => (
              <div key={i} data-testid={`ingredient-${i}`} className="group">
                <div className="aspect-square overflow-hidden bg-surface mb-5">
                  <img
                    src={INGREDIENT_IMAGES[i]}
                    alt={ing.t}
                    className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  />
                </div>
                <h4 className="font-serif text-2xl md:text-3xl text-ink font-light tracking-tight">
                  {ing.t}
                </h4>
                <p className="mt-3 text-sm text-ink-muted font-light leading-relaxed">
                  {ing.d}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Produccion;
